module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/spot03_point-51192af2be6b5f1fc0f28a7604ec92c8.jpg";